import { SubState } from "../state";
import { StepGuard } from "../../core/model/step-guard";
import { AppState } from "../state.module";
import { Shipment } from "../../core/model/shipment";
import { Party } from "../../core/model/party";
export class ShipmentState implements SubState {
  constructor(private _parent: AppState = null,
    private _step: StepGuard = new StepGuard(),
    private _shipment: Shipment = new Shipment(),
    private _shipmentId: string = null) {
  }

  get parent(): AppState {
    return this._parent;
  }

  get step(): StepGuard {
    return this._step;
  }

  get shipment(): Shipment {
    return this._shipment;
  }

  get shipmentId(): string {
    return this._shipmentId;
  }


  withParent(parent: AppState): ShipmentState {
    return new ShipmentState(
      parent,
      this._step,
      this._shipment,
      this._shipmentId
    );
  }

  addCurrentShipmentWizzardStep(step: StepGuard): AppState {
    return this._parent.withShipment(this.recreate(
      step,
      this._shipment,
      this._shipmentId
    ));
  }

  addReceiverType(receiverType: string): AppState {
    return this._parent.withShipment(this.recreate(
      this._step,
      this._shipment.withType(receiverType),
      this._shipmentId
    ));
  }

  addSelectedOrder(order: string): AppState {
    return this._parent.withShipment(this.recreate(
      this._step,
      this._shipment.withSelectedOrder(order),
      this._shipmentId
    ))
  }

  addReceiver(receiver: Party): AppState {
    return this._parent.withShipment(this.recreate(
      this._step,
      this._shipment.withReceiver(receiver),
      this._shipmentId
    ));
  }

  addSender(sender: Party): AppState {
    return this._parent.withShipment(this.recreate(
      this._step,
      this._shipment.withSender(sender),
      this._shipmentId
    ))
  }

  addShipmentId(shipmentId: string): AppState {
    return this._parent.withShipment(this.recreate(
      this._step,
      this._shipment.withId(shipmentId),
      shipmentId
    ));
  }

  private recreate(step: StepGuard,
    shipment: Shipment,
    id: string): ShipmentState {
    return new ShipmentState(
      null,
      step,
      shipment,
      id
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/state/shipment/shipment-state.ts